import { Injectable } from '@angular/core';
import { TimeBlockAbsenceModel } from '../../../models/timeblock/time-block.model';
import { ITimeBlockComponentItem } from '../../../../features/calendar/components/time-block/types/time-block-component-item-types';

@Injectable({
  providedIn: 'root',
})
export class TimeBlockFilterService {
  public static removeNonWorkingTimeTimeBlocks(timeBlocks: readonly ITimeBlockComponentItem[]) {
    return timeBlocks.filter((timeBlock) => {
      return !(
        timeBlock.timeBlockModel instanceof TimeBlockAbsenceModel &&
        !timeBlock.timeBlockModel.reason.isWorkingTime
      );
    });
  }
}
